function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { get, post, AuthenticationTypes } from '@shared/services/http/httpProtocol';
const commonHttpOptions = {
    requireCorrelationId: true,
    stringifyPostData: false,
    authenticationType: AuthenticationTypes.Spza,
    setBearerHeader: true
};
export const ReviewCommentsQueryStrings = {
    OfferId: 'offerId',
    ApiVersion: 'api-version'
};
/**
 * Toggles marked as helpful for a given review
 * @param Object containing named parameters for the call
 * @returns Promise with the response, both for success and failure
 */ export function setReviewMarkedAsHelpful(_) {
    return _setReviewMarkedAsHelpful.apply(this, arguments);
}
function _setReviewMarkedAsHelpful() {
    _setReviewMarkedAsHelpful = _async_to_generator(function*({ offerId, reviewId, reviewsAPI, reviewsAPIVersion, isHelpful, source }) {
        try {
            const result = yield post(`${reviewsAPI}/${reviewId}/helpful`, commonHttpOptions).addQueryEntry(ReviewCommentsQueryStrings.ApiVersion, reviewsAPIVersion).addQueryEntry(ReviewCommentsQueryStrings.OfferId, offerId).setData({
                is_helpful: isHelpful,
                source
            }).request();
            return {
                result
            };
        } catch (error) {
            var _error_response;
            return {
                error: ((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.text) || error
            };
        }
    });
    return _setReviewMarkedAsHelpful.apply(this, arguments);
}
/**
 * Get a list of review ids which the current user marked as helpful for a given offer
 * @param Object containing named parameters for the call
 * @returns Promise with the response, containing a list of comments for the given review
 */ export function getUserReviewsMarkedAsHelpful(_) {
    return _getUserReviewsMarkedAsHelpful.apply(this, arguments);
}
function _getUserReviewsMarkedAsHelpful() {
    _getUserReviewsMarkedAsHelpful = _async_to_generator(function*({ offerId, reviewsAPI, reviewsAPIVersion }) {
        try {
            const reviewIds = yield get(`${reviewsAPI}/helpful`, commonHttpOptions).addQueryEntry(ReviewCommentsQueryStrings.ApiVersion, reviewsAPIVersion).addQueryEntry(ReviewCommentsQueryStrings.OfferId, offerId).request();
            return {
                reviewIds
            };
        } catch (error) {
            return {
                error,
                reviewIds: []
            };
        }
    });
    return _getUserReviewsMarkedAsHelpful.apply(this, arguments);
}
